// Consolidated environment configuration
export const env = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  // Add other environment variables as needed
};

// Environment utility to determine development vs production environment
export const isDevelopment = window.location.hostname === 'localhost' || 
                             window.location.hostname === '127.0.0.1';

// Get environment string
export const getEnvironment = () => isDevelopment ? 'development' : 'production'; 